/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "w7ejDZ8SWv8&t",
    title: "React JS Crash Course",
    creator: "Traversy Media",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654019722/magnet%20library/AKedOLSxHOOxxa9Af8Bfb2XMop3lm4tor9bViWiC-d5aaw_s88-c-k-c0x00ffffff-no-rj_rivjfz.jpg",
    categoryName: "Learning",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654019505/magnet%20library/hqdefault_bokgim.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/T6o3Ci8Ieag/mqdefault_6s.webp?du=3000&sqp=CPip7pIG&rs=AOn4CLAYZeTsaOHS8LN_WUQLoAzhk2y5rQ",
    description: `Get started with React in this crash course. We will be building a task tracker app and look at components, props, state, hooks, working with an API and more.`,
  },
  {
    _id: "7BOi0H59tXY&ab",
    title:
      "Steve Harvey Leaves the Audience SPEECHLESS | One of the Best Motivational Speeches Ever",
    creator: "MotivationHub",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654020741/magnet%20library/AKedOLRxR0LxkA0q7Iszzh9Fggi0F7avNa45DMCnpbyf_s88-c-k-c0x00ffffff-no-rj_nismna.jpg",
    categoryName: "Motivation",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654020529/magnet%20library/hq720_z7kxmo.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/o3K_HbpWNpg/mqdefault_6s.webp?du=3000&sqp=CPD9xJMG&rs=AOn4CLCgLMxasUJZnmUFtPFFas3b9KOwEA",
    description: `Steve Harvey, host of Family Feud and The Steve Harvey Morning show, stand-up comedian, and author, delivers one of the best motivational speeches you will ever hear. 
    "Your track record of surviving bad days is 100%. You have survived every hater, every eviction, and firing. Now you need to protect yourself from negativity, block all the negative thoughts by starting your day with gratitude. Gratitude erases negativity."
    ― Steve Harvey 

    If you know someone who could use this video, share it with them!
    Steve Harvey

    Steve Harvey is an American television and radio presenter, actor, author, businessman, and former stand–up comedian. He hosts The Steve Harvey Morning Show, Family Feud, Celebrity Family Feud and the Miss Universe competition, and upcoming limited-run arbitration-based court comedy, Judge Steve Harvey.`,
  },
  {
    _id: "x1YGCzmxEoo&ab",
    title:
      "Hair by Mr Bean of London | Episode 14 | Widescreen | Mr Bean Official",
    creator: "Mr Bean",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654024253/magnet%20library/AKedOLSOkEcl2lDSFEBtGFoNL8eLULm1RkXnBcb3i45uxA_s88-c-k-c0x00ffffff-no-rj_w4rr1t.jpg",
    categoryName: "Comedies",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654024025/magnet%20library/hq720_hr1koh.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/7nGz7xgGJzc/mqdefault_6s.webp?du=3000&sqp=CLWq7pIG&rs=AOn4CLBnbUxwvM29ig6uQQ26RdWg_VTRJQ",
    description: `Bean ends up holding the fort for his hairdresser and gives several customers terrible haircuts. Bean then attends a fete but cheats at all the games and enters Teddy into a dog show. Later, after a train journey Bean loses his ticket so tries various ways to leave without being seen by the guards. His efforts fail as he ends up on a mail train bound for Moscow.Welcome to the official Mr Bean Channel. Here you will find all of your favourite Mr Bean moments from the classic series with Rowan Atkinson and his new animated adventures. Make sure to subscribe and never miss a Full Episode of Mr Bean, or Mr Bean Compilations and clips as well as originals including Mr Bean Comics.
    `,
  },
  {
    _id: "HZ-4K2IN7DY&ab",
    title:
      "Award Winning Hindi Short Film | The Pizza - Story Of Life & Relationships | Six Sigma Films",
    creator: "Terribly Tiny Tales",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654023277/magnet%20library/AKedOLSBXjKdR2um146KvF8zLkLzztUGC_FOHmPYgj7p_s88-c-k-c0x00ffffff-no-rj_g2oq3x.jpg",
    categoryName: "Short Flims",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654022973/magnet%20library/hq720_ozisxg.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/1wrI6yjqfd8/mqdefault_6s.webp?du=3000&sqp=CKjO7pIG&rs=AOn4CLBnVz6tiAfM9zwZuJoYOuUYbUGwsA",
    description: `Kaande Pohe - A Maharashtrian snack traditionally served when a boy visits a girls' family for the first time in an arranged marriage set up. The day is called 'Kaande Pohe Cha Kaaryakaram'.

    There is no data on this strategy's success rate. :) 
    
    Meet Sanjay and Manisha who are on their 'Kaande Pohe Cha Kaaryakaram'.
    
    Watch our latest short film starring Ahsaas Channa and Tushar Pandey to see what secrets Manisha has to reveal.`,
  },
  {
    _id: "qp0HIF3SfI4",
    title: "How great leaders inspire action | Simon Sinek",
    creator: "Gravero",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1650173667/magnet%20library/Ted/ted_pxlqat.jpg",
    categoryName: "TED",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1650172786/magnet%20library/Ted/hq720_divxvw.webp",
    dynamicImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1650172889/magnet%20library/Ted/mqdefault_6s_efunwu.webp",
    description: `Simon Sinek presents a simple but powerful model for how leaders inspire action, starting with a golden circle and the question "Why?"  His examples include Apple, Martin Luther King, and the Wright brothers -- and as a counterpoint Tivo, which (until a recent court victory that tripled its stock price) appeared to be struggling.`,
  },
  {
    _id: "dhYOPzcsbGM&ab",
    title: "Alan Walker, Sabrina Carpenter & Farruko - On My Way",
    creator: "Alan Walker",
    creatorImage:
      "https://yt3.ggpht.com/aVVgun46AV1oXiN5TJh3lmsuWr2bKU2LW1163WB0GsZrthm4wfof6Lq8OVH5qOLq9zOQg8yj=s48-c-k-c0x00ffffff-no-nd-rj",
    categoryName: "Music",
    staticImage:
      "https://i.ytimg.com/vi/dhYOPzcsbGM/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAudZaE2MOvxewPBMC-iUpj2wIDhA",
    dynamicImage:
      "https://i.ytimg.com/an_webp/dhYOPzcsbGM/mqdefault_6s.webp?du=3000&sqp=CNHH7pIG&rs=AOn4CLBMGY1rTWmVr8mIroZnjJKU48MQeQ",
    description: `Walkers! The music video for my brand new single “On My Way” with Sabrina Carpenter and Farruko is finally here. This is the start of a whole new journey that I can’t wait to share with you all. I hope you like it, and are as excited as I am!`,
  },
  {
    _id: "GpiM_qi5mAc&ab",
    title:
      "How to invest in stocks for beginners 2022 - Basics of stock market for beginners",
    creator: "Groww",
    creatorImage:
      "https://yt3.ggpht.com/ytc/AKedOLQij4mjnGU5Mkn1EMxVRGsAjdTNjR7pF8-bFngzYQ=s88-c-k-c0x00ffffff-no-rj",
    categoryName: "Stocks",
    staticImage:
      "https://i.ytimg.com/vi/GpiM_qi5mAc/hq720.jpg?sqp=-oaymwEXCNAFEJQDSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCZL308uriuzeBGOdU3bAPzFAEm-w",
    dynamicImage:
      "https://i.ytimg.com/an_webp/GpiM_qi5mAc/mqdefault_6s.webp?du=3000&sqp=CJPO7pIG&rs=AOn4CLBBaVc7NWul5BR-HFu4Xd8SRpratg",
    description: `How to invest in stocks for beginners 2022 - Basics of stock market for beginners

    #basicsofstockmarketforbeginners #howtoinvestinstocks
    
    Check out our new channel for Trading and F&O: https://openinapp.co/youtube/trading-...`,
  },
  {
    _id: "wUEl8KrMz14&ab",
    title: "Why sitting is bad for you - Murat Dalkilinç",
    creator: "TED-ed",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654017367/magnet%20library/HjXKmDGoAp6b-JdGYpqJYYeN4S_CMpD_kqWvldpN53cbzn-i73t6mVNo8mNki-xLPwi0BVSFi-o_s88-c-k-c0x00ffffff-no-rj_fnyqae.jpg",
    categoryName: "TED",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654017222/magnet%20library/hq720_aecm39.webp",
    dynamicImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1650172889/magnet%20library/Ted/mqdefault_6s_efunwu.webp",
    description: `Sitting down for brief periods can help us recover from stress or recuperate from exercise. But nowadays, our lifestyles make us sit much more than we move around. Are our bodies built for such a sedentary existence? Murat Dalkilinç investigates the hidden risks of sitting down. 

    Lesson by Murat Dalkilinç, animation by Oxbow Creative.`,
  },
  {
    _id: "xu-WuJtOl0c&ab",
    title:
      "Winners Need Discipline Not Motivation | Powerful Inspirational Speech",
    creator: "Motivational Stories",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021076/magnet%20library/AKedOLSMc8cutujkpmVROrmiaXTbYQWaeXXGzK5sZaQR-Q_s88-c-k-c0x00ffffff-no-rj_ieqdeq.jpg",
    categoryName: "Motivation",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654020982/magnet%20library/hq720_qfejex.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/o3K_HbpWNpg/mqdefault_6s.webp?du=3000&sqp=CPD9xJMG&rs=AOn4CLCgLMxasUJZnmUFtPFFas3b9KOwEA",
    description: `This Inspiration speech will answer a common question, which is more important Discipline or Motivation. How are the high achievers able to accomplish so much? Are they disciplines or are they motivated to get there?`,
  },
  {
    _id: "1nydxbGhgv8&ab",
    title: "Dua Lipa - Blow Your Mind (Mwah) (Official Video)",
    creator: "Dua Lipa",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654016373/magnet%20library/AKedOLRjI68131sY_h0hUZkGgxqMDlKe-IosbR65zo476A_s88-c-k-c0x00ffffff-no-rj-mo_ks09mi.jpg",
    categoryName: "Music",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654016219/magnet%20library/hq720_gzac6r.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/dhYOPzcsbGM/mqdefault_6s.webp?du=3000&sqp=CNHH7pIG&rs=AOn4CLBMGY1rTWmVr8mIroZnjJKU48MQeQ",
    description: `The official music video for Dua Lipa - Blow Your Mind (Mwah)

    Taken from her self-titled debut studio album released in 2017, which featured the hit singles 'Be The One', 'IDGAF', 'Hotter Than Hell' & 'New Rules'
    
    Subscribe to the Dua Lipa channel for all the best and latest official music videos, behind the scenes and live performances. 
    About Dua Lipa:
    Born and raised in London to Kosovar-Albanian parents Dua Lipa signed to Warner Records in 2015, releasing her self titled debut in 2017 which featured the hit singles, 'Be The One', 'IDGAF', 'Hotter Than Hell' & her first UK #1 hit 'New Rules'. 
`,
  },

  {
    _id: "1wrI6yjqfd8&ab",
    title:
      "Award Winning Hindi Short Film | Noise - The Rickshawala | Six Sigma Films",
    creator: "Six Sigma Films",
    creatorImage:
      "https://yt3.ggpht.com/ytc/AKedOLT5gsEVbsvnGmgzPiEGJJLY-A0VjTqDaqCzvtrrkQ=s88-c-k-c0x00ffffff-no-rj",
    categoryName: "Short Flims",
    staticImage:
      "https://i.ytimg.com/vi/1wrI6yjqfd8/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAF6hmtrLicF3eFUacTyq0lgqv2pg",
    dynamicImage:
      "https://i.ytimg.com/an_webp/1wrI6yjqfd8/mqdefault_6s.webp?du=3000&sqp=CKjO7pIG&rs=AOn4CLBnVz6tiAfM9zwZuJoYOuUYbUGwsA",
    description: `This is story of Munna, a rikshawala and Stuti, a young girl and anger issues around them . An argument between a couple shows how anger of a person can transform the lives of others. This subtitled  award winning Hindi short Movie directed by Sandhya Ram Mahindra features Munna Lohar, Stuti Agarwal, Dinesh Sahdeo, R K Chhadd, Anu Radha Pandit . This short film  was awarded Best Indian Short Film at Ooty International Short Film Festival 2021 and Best Director (Special Mention) at Emerald Peacock Film Festival. `,
  },
  {
    _id: "q1i6zruSgl8&ab",
    title: "Jim Cramer explains why he's bullish on bank stocks",
    creator: "CNBC Television",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021735/magnet%20library/AKedOLTHxFZyBnHstDCHoPUzA2AWePuROpPMnKC2E0UZPw_s88-c-k-c0x00ffffff-no-rj_u9db34.jpg",
    categoryName: "Stocks",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021698/magnet%20library/hqdefault_dqsq2b.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/GpiM_qi5mAc/mqdefault_6s.webp?du=3000&sqp=CJPO7pIG&rs=AOn4CLBBaVc7NWul5BR-HFu4Xd8SRpratg",
    description: `How to invest in stocks for beginners 2022 - Basics of stock market for beginners
    'Mad Money' host Jim Cramer and the Squawk on the Street team break down shares of e-commerce companies and banks after the market open on Tuesday.`,
  },

  {
    _id: "tJtCcm7PUvA&ab",
    title: "My Long Walk Across India for Women's Freedom | Srishti Bakshi",
    creator: "TED",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654017750/magnet%20library/AKedOLSAltH3yarKh0eytWLSLtB9-kPpMLM5EejH-GAZIg_s88-c-k-c0x00ffffff-no-rj_teg1ko.jpg",
    categoryName: "TED",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654017600/magnet%20library/hq720_ihjnqz.webp",
    dynamicImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1650172889/magnet%20library/Ted/mqdefault_6s_efunwu.webp",
    description: `There are 600 million women in India -- yet they are rarely seen outdoors after sunset because of safety concerns like harassment and catcalls. On a mission to create safer public spaces, women's rights advocate Srishti Bakshi talks about how she embarked on a 2,300-mile walk across the length of India (a distance equivalent to traveling from New York City to Los Angeles), conducting driving workshops to empower women's mobility across the country. "The more women see other women in public spaces, the more safe, independent and empowered each of us will be," Bakshi says.`,
  },

  {
    _id: "T6o3Ci8Ieag",
    title:
      "What Is GitHub? | What Is GitHub And How To Use It? | GitHub Tutorial For Beginners | Simplilearn",
    creator: "Simplilearn",
    creatorImage:
      "https://yt3.ggpht.com/ytc/AKedOLTaNnIZrEVNHk-OgfTRlO1n2aeAZ657f5FrG-5EaA=s176-c-k-c0x00ffffff-no-rj",
    categoryName: "Learning",
    staticImage:
      "https://i.ytimg.com/vi/T6o3Ci8Ieag/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBGHqf515GOtM2Ku0ng-JivioDv6w",
    dynamicImage:
      "https://i.ytimg.com/an_webp/T6o3Ci8Ieag/mqdefault_6s.webp?du=3000&sqp=CPip7pIG&rs=AOn4CLAYZeTsaOHS8LN_WUQLoAzhk2y5rQ",
    description: `This video on What is GitHub will help you understand the basics of GitHub with the help of a used case. We will see the basics of the version control system and Git. Moving forward, we will understand the relevance of GitHub and discuss some of its features. Towards the end, we shall see some of the competitors of GitHub.`,
  },
  {
    _id: "VSceuiPBpxY&ab",
    title: "THE MINDSET OF A WINNER | Kobe Bryant Champions Advice",
    creator: "Motiversity",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021363/magnet%20library/AKedOLQ3FtoYqwDf6LPVnwaqEz6qJrahXobKsuVrI-SADw_s88-c-k-c0x00ffffff-no-rj_q6i5fv.jpg",
    categoryName: "Motivation",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021020/magnet%20library/hq720_ehquvj.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/o3K_HbpWNpg/mqdefault_6s.webp?du=3000&sqp=CPD9xJMG&rs=AOn4CLCgLMxasUJZnmUFtPFFas3b9KOwEA",
    description: `"You Want First Place Come Play With Me, You Want Second Place Go Somewhere Else." KOBE BRYANT. The Mindset Of A Winner.
    Amazing Authors like Brendan Burchard, David Goggins, James Clear, Dale Carnegie, Stephen R. Covey, Nick Winter, Tara Westover, Mel Robbins, Steven Pressfield, Charles Duhigg, Elizabeth Gilbert, David Allen, Billy Alsbooks, Walter Bond, Kevin Kruse, and Zac Bissonnette.`,
  },
  {
    _id: "NobrEt1Zeco&ab",
    title: "Miss To Mrs - A Short Film On Working Women | Why Not | Life Tak",
    creator: "Life Tak",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654023026/magnet%20library/Ux-fKJQ-PVLqj8cxcBs1KR14zWC7KH9Wvw43WW1-JIf7jDSaJKbBkVErNQ_M5t2wL9PL6caC0w_s88-c-k-c0x00ffffff-no-rj_cmmcoc.jpg",
    categoryName: "Short Flims",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654022797/magnet%20library/hq720_xp39zz.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/1wrI6yjqfd8/mqdefault_6s.webp?du=3000&sqp=CKjO7pIG&rs=AOn4CLBnVz6tiAfM9zwZuJoYOuUYbUGwsA",
    description: `One call from HR got her thinking about who she really was and what she actually wants to do. Watch till the end to know what she decides.`,
  },

  {
    _id: "7nGz7xgGJzc",
    title: "Adorable 3-Year-Old Periodic Table Expert Brielle",
    creator: "TheEllenShow",
    creatorImage:
      "https://yt3.ggpht.com/I0j6g1bOYmGniEtkySB7tmvHxmo5InW1gqGRZJfFT_ErwZbRMKATBkUQyYutEPTB2A-Z2C0Z6w=s88-c-k-c0x00ffffff-no-rj",
    categoryName: "Comedies",
    staticImage:
      "https://i.ytimg.com/vi/7nGz7xgGJzc/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAO5VeHAjVbjA_4rRt3B2HiIdoZ9A",
    dynamicImage:
      "https://i.ytimg.com/an_webp/7nGz7xgGJzc/mqdefault_6s.webp?du=3000&sqp=CLWq7pIG&rs=AOn4CLBnbUxwvM29ig6uQQ26RdWg_VTRJQ",
    description: `After Ellen saw Brielle's video on ellentube, she invited her to showcase her science smarts on the show!`,
  },
  {
    _id: "Jg14QSiNdRE&ab",
    title: "6 TOP Stocks To Buy in June 2022 (High Growth)",
    creator: "Charlie Chang",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654022059/magnet%20library/AKedOLSIJCWtw867DUyDDz5ta0FeclwIOxyUOvTQrmm0xg_s88-c-k-c0x00ffffff-no-rj_lkpbaq.jpg",
    categoryName: "Stocks",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021595/magnet%20library/hqdefault_xqveej.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/GpiM_qi5mAc/mqdefault_6s.webp?du=3000&sqp=CJPO7pIG&rs=AOn4CLBBaVc7NWul5BR-HFu4Xd8SRpratg",
    description: `In this video, I’m going over 6 top stocks to buy now in June 2022. Moomoo is hooking it up for my audience with this exclusive offer. It's their best promotion yet and I highly recommend signing up with my link, making your first deposit, and getting your free stocks!
    My take on investing: Under 10% of portfolio in individual companies, 90%+ in index funds. Picking stocks is inherently not the smartest move! Long term investing in the market IS the smart move.

    With the Russia-Ukraine situation affecting the markets, this could be a very interesting entry point for those of you who waited to invest. Stocks are overall down quite a bit (take a look at the S&P 500 since the start of 2022) However, I want to reiterate that index fund investing is the best way to invest for long-term wealth, so if you can, try and keep a small portion of your portfolio in individual companies.
    
    These are LONG TERM PICKS - for short term, all of these companies can go down or up. Do NOT trade options with these companies as their price movement can be all over the place, especially during earnings. The overall market is down, especially higher growth sectors like tech. And volatility is everywhere.    `,
  },

  {
    _id: "kY7a_ReAcas&ab",
    title:
      "Kho Gaye Hum Kahan - Lyrical |Baar Baar Dekho |Sidharth Malhotra, Katrina Kaif |Jasleen R, Prateek K",
    creator: "Zee Music Company",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654016752/magnet%20library/EEGERwlaKJd27zSEPQF3d__-tPyppIgFfKvNfBkWa7ssMKBWqQUbuCTLe-kAnTB1r6kJQVxyxwY_s88-c-k-c0x00ffffff-no-rj_tmdug9.jpg",
    categoryName: "Music",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654016560/magnet%20library/hq720_niyd6t.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/dhYOPzcsbGM/mqdefault_6s.webp?du=3000&sqp=CNHH7pIG&rs=AOn4CLBMGY1rTWmVr8mIroZnjJKU48MQeQ",
    description: `Presenting the lyrical video of Kho Gaye Hum Kahan sung by Jasleen Royal & Prateek Kuhad.

    To set Kho Gaye Hum Kahan as your caller tune BBD5 to 57575
    
    Title: Kho Gaye Hum Kahan
    Music : Jasleen Royal
    Lyrics : Prateek Kuhad
    Singers : Jasleen Royal & Prateek Kuhad
    Mix&Mastered by : Eric Pillai (Future Sound Of Bombay)
    Mixing Assistant : Michael Edwin Pillai & Lucky 
    Cast : SIDHARTH MALHOTRA, KATRINA KAIF, SARIKA, RAM KAPOOR, TAAHA SHAH, SAYANI GUPTA & ROHAN JOSHI 
    Banner : EROS INTERNATIONAL presents in association with EXCEL ENTERTAINMENT and DHARMA PRODUCTIONS, an ARCLIGHT FILMS PRODUCTION
    Director : Nitya Mehra`,
  },

  {
    _id: "HAnw168huqA",
    title: "Think Fast, Talk Smart: Communication Techniques",
    creator: "Stanford Graduate School of Business",
    creatorImage:
      "https://yt3.ggpht.com/ytc/AKedOLRSMpZ9D2BtDJbw9rL4jBf7TvEZaDFgZ49b_Ah16Q=s88-c-k-c0x00ffffff-no-rj",
    categoryName: "Motivation",
    staticImage:
      "https://i.ytimg.com/vi/o3K_HbpWNpg/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCLXvjkxO12SOw57bNsppcNfEYRWw",
    dynamicImage:
      "https://i.ytimg.com/an_webp/o3K_HbpWNpg/mqdefault_6s.webp?du=3000&sqp=CPD9xJMG&rs=AOn4CLCgLMxasUJZnmUFtPFFas3b9KOwEA",
    description: `Communication is critical to success in business and in life. Concerned about an upcoming interview? Anxious about speaking up during a meeting? Learn and practice techniques that will help you speak spontaneously with greater confidence and clarity. Matt Abrahams is a lecturer of strategic communication at Stanford GSB and the host of "Think Fast, Talk Smart: The Podcast," a show with more tips and best practices on becoming a more engaging speaker.`,
  },
  {
    _id: "1F0CE1U5Wxo&ab",
    title:
      "Award Winning Hindi Short Film | The Pizza - Story Of Life & Relationships | Six Sigma Films",
    creator: "Six Sigma Flims",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654023099/magnet%20library/AKedOLT5gsEVbsvnGmgzPiEGJJLY-A0VjTqDaqCzvtrrkQ_s88-c-k-c0x00ffffff-no-rj_cmpf6a.jpg",
    categoryName: "Short Flims",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654022864/magnet%20library/hq720_deq035.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/1wrI6yjqfd8/mqdefault_6s.webp?du=3000&sqp=CKjO7pIG&rs=AOn4CLBnVz6tiAfM9zwZuJoYOuUYbUGwsA",
    description: `Ranked as one of the 5 top favorite short films of the viewers in 2021 by "Film Critics Guild". An emotional drama about a widower old man in Mumbai. His only son lives in Australia and he is all alone in his big flat. One day he orders the Pizza but delivery boy finds that address is wrong. What happens next will touch your heart. This multiple award winning Hindi short movie is directed by Mahendra Dongre. This film on loneliness & anxiety of old people features Rajan Kajarolkar, Kshitij Bhandary.`,
  },

  {
    _id: "Wn_Kb3MR_cU&ab",
    title:
      "Build and Deploy a Modern Web 3.0 Blockchain App | Solidity, Smart Contracts, Crypto",
    creator: "Javascript Mastery",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654019320/magnet%20library/AKedOLSmjxIU9yuwvDGSuHZ88rKyfjRSmHJeKFmQZbnFiQ_s88-c-k-c0x00ffffff-no-rj_xrpd4x.jpg",
    categoryName: "Learning",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654019106/magnet%20library/hq720_qrfl3n.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/T6o3Ci8Ieag/mqdefault_6s.webp?du=3000&sqp=CPip7pIG&rs=AOn4CLAYZeTsaOHS8LN_WUQLoAzhk2y5rQ",
    description: `Web 3.0 has the potential to change the internet as we know it, forever. You're still early in catching the trend right now and building your first blockchain cryptocurrency app. 
    With a stunning design, connected to the blockchain, metamask pairing, interaction with smart contracts, sending Ethereum through the blockchain network, writing solidity code, and much more, Krypt is the best #Web3 #Blockchain app that you can currently find on YouTube and the entire internet.
    In this video, you'll learn:
    - How to connect a regular React.js application to the blockchain and pair it to your Ethereum wallet using MetaMask
    - You'll also learn how to write Smart Contracts on the Ethereum network using the #Solidity programming language
    - Essentially, in this single video, you'll learn how to create a full-fledged Web 3.0 application that allows users to send transactions through the blockchain`,
  },
  {
    _id: "c7QYEedjb_o",
    title:
      "ABHISHEK UPMANYU |Friends, Crime, & The Cosmos | Stand-Up Comedy by Abhishek Upmanyu",
    creator: "Abhishek Upmanyu",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654024615/magnet%20library/AKedOLQFBbx9iNh-JQvEo61AHkcDrkbY-Pavaba-y2ck9w_s88-c-k-c0x00ffffff-no-rj_pfbttl.jpg",
    categoryName: "Comedies",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654024195/magnet%20library/hq720_nogm66.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/7nGz7xgGJzc/mqdefault_6s.webp?du=3000&sqp=CLWq7pIG&rs=AOn4CLBnbUxwvM29ig6uQQ26RdWg_VTRJQ",
    description: `Jokes about Friends, Crime Patrol and The Cosmos. Hope you enjoy it!

    Credits:
    
    Shot at: The Habitat Music & Cafe, Khar, Mumbai
    Shot By: Myoho Films
    Edited by: Abhishek Upmanyu & Karan Asnani
    Sound Recording: The Habitat
    Sound Mixing: Sohail Gandhi
    Written by: Abhishek Upmanyu
    
    Special Thanks: Balraj Ghai, Vipul D Shah`,
  },

  {
    _id: "vUCM_0evdQY&ab",
    title:
      "Ae Dil Hai Mushkil - Full Song Video | Karan Johar | Aishwarya, Ranbir, Anushka | Pritam | Arijit",
    creator: "Sony Music India",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654016135/magnet%20library/vJEsALWnQIwPZ2oaVbFWPu1n4L0CDkHpAdGJ-KBPFsxM9hsMsvExFK1mnCGUrMzfC67XPVThmQ_s88-c-k-c0x00ffffff-no-rj_hfneng.jpg",
    categoryName: "Music",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654015564/magnet%20library/hq720_jpvaem.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/dhYOPzcsbGM/mqdefault_6s.webp?du=3000&sqp=CNHH7pIG&rs=AOn4CLBMGY1rTWmVr8mIroZnjJKU48MQeQ",
    description: `You've already made it one of the most loved tracks of the year, here's presenting the Ae Dil Hai Mushkil Music Video.
    Hear It First on Saavn!
    Music- Pritam
    Lyrics- Amitabh Bhattacharya
    Singer- Arijit Singh
    Sound Design- Dj Phukan, Sunny M.R.
    Music Programmers- Prasad Sashte, Sunny M.R. , Dj Phukan
    Mix- Sunny M.R. & Shadab Rayeen
    Master- Shadab Rayeen@Newedge
    Assistant - Abhishek Sortey
    Recording Engineer's- Ashwin Kulkarni, Himanshu Shirlekar, Kaushik Das, Lee Slater`,
  },
  {
    _id: "mB4FO1itCi0&ab",
    title: "Why should you read “Kafka on the Shore”? - Iseult Gillespie",
    creator: "TED-ed",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654017367/magnet%20library/HjXKmDGoAp6b-JdGYpqJYYeN4S_CMpD_kqWvldpN53cbzn-i73t6mVNo8mNki-xLPwi0BVSFi-o_s88-c-k-c0x00ffffff-no-rj_fnyqae.jpg",
    categoryName: "TED",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654018047/magnet%20library/hq720_nmworh.webp",
    dynamicImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1650172889/magnet%20library/Ted/mqdefault_6s_efunwu.webp",
    description: `Follow the entwined destinies of Kafka and Nakata in Haruki Murakami’s mind-bending novel “Kafka on the Shore.”

    --
    
    Desperate to escape his tyrannical father and the family curse he feels doomed to repeat, Haruki Murakami’s teenage protagonist renames himself “Kafka” after his favorite author and runs away from home. So begins “Kafka on the Shore”— an epic literary puzzle filled with time travel, hidden histories and magical underworlds. Iseult Gillespie dives into Murakami’s mind-bending and whimsical novel.
    
    Lesson by Iseult Gillespie, directed by Cabong Studios.`,
  },
  {
    _id: "LehcVBCYbwE&ab",
    title: "Best Stocks to Trade For Tomorrow with logic",
    creator: "Power Of Stocks",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654022196/magnet%20library/AKedOLTJsRMFA9YP8MqwBsr4HLFTMjkaF-SSPJgSjmNJ4A_s88-c-k-c0x00ffffff-no-rj_bnlsz4.jpg",
    categoryName: "Stocks",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654021644/magnet%20library/hqdefault_shrf0l.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/GpiM_qi5mAc/mqdefault_6s.webp?du=3000&sqp=CJPO7pIG&rs=AOn4CLBBaVc7NWul5BR-HFu4Xd8SRpratg",
    description: `Shop official POS Merch &Trading Journal:- http://www.powerofstocksmerch.com

    Power of Stocks learning App:- https://play.google.com/store/apps/de...
    ----------------------------      
    You Can Open a Trading account from the below links:-
    Fyers Link:- https://open-account.fyers.in/?utm-so...
    Zerodha link:- https://zerodha.com/open-account?c=ZM... 
    Alice blue:- http://joinaliceblueonline.com/Power_...
    ----------------------------
    Shop official POS Merch:- http://www.powerofstocksmerch.com
    Subanjali vlog link:- https://youtu.be/-POK0aX19SI
    Official Telegram Channel:-https://t.me/joinchat/AAAAAEtev9UoDUB...
    Follow me on Instagram:- https://www.instagram.com/powerofstoc...
    ----------------------------
    Monitor I use- https://amzn.to/2YATckg
    Camera I use- https://amzn.to/3oPYjrR
    Laptop I use- https://amzn.to/3DtExXi
    Mic I use- https://amzn.to/2YuohpT
    Headphone I use- https://amzn.to/2X4k63S `,
  },

  {
    _id: "B31LgI4Y4DQ&ab",
    title: "Data Structures - Full Course Using C and C++",
    creator: "freeCodeCamp.org",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654020235/magnet%20library/AKedOLRR2uNiXJiFH-XRmtGgkdICxTuDJxCPJidKFRNCNg_s88-c-k-c0x00ffffff-no-rj_tdrpo2.jpg",
    categoryName: "Learning",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654020108/magnet%20library/hq720_ghwifc.jpg",
    dynamicImage:
      "https://i.ytimg.com/an_webp/T6o3Ci8Ieag/mqdefault_6s.webp?du=3000&sqp=CPip7pIG&rs=AOn4CLAYZeTsaOHS8LN_WUQLoAzhk2y5rQ",
    description: `Learn about data structures in this comprehensive course. We will be implementing these data structures in C or C++.  
    
    ✏️ Course developed by Harsha and Animesh from MyCodeSchool.
    🔗 Read all about their amazing story here: https://www.freecodecamp.org/news/myc...
    🔗 Check out the MyCodeSchool channel: https://www.youtube.com/user/mycodesc...
    🔗 Check out the MyCodeSchool website: http://mycodeschool.com/`,
  },
  {
    _id: "2mSr6GgQV2Y&ab",
    title: "JUDO Bean | Funny Clips | Mr Bean Official",
    creator: "Mr Bean",
    creatorImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654024253/magnet%20library/AKedOLSOkEcl2lDSFEBtGFoNL8eLULm1RkXnBcb3i45uxA_s88-c-k-c0x00ffffff-no-rj_w4rr1t.jpg",
    categoryName: "Comedies",
    staticImage:
      "https://res.cloudinary.com/dflebgpde/image/upload/v1654024116/magnet%20library/hqdefault_gyolzg.webp",
    dynamicImage:
      "https://i.ytimg.com/an_webp/7nGz7xgGJzc/mqdefault_6s.webp?du=3000&sqp=CLWq7pIG&rs=AOn4CLBnbUxwvM29ig6uQQ26RdWg_VTRJQ",
    description: `Mr Bean tries his hand at martial arts, but is a little reluctant to be thrown to the ground!Welcome to the official Mr Bean Channel. Here you will find all of your favourite Mr Bean moments from the classic series with Rowan Atkinson and his new animated adventures. Make sure to subscribe and never miss a Full Episode of Mr Bean, or Mr Bean Compilations and clips as well as originals including Mr Bean Comics.`,
  },
];
